import { action, observable } from "mobx";
import apiCaller from "../utils/api-caller";

class webSettingStore {

  @observable fontFamilies = [
    { value: 'BigCaslonMedium', label: 'Big Caslon Medium' },
    { value: 'CormorantGaramondBold', label: 'Cormorant Garamond Bold' },
    { value: 'CormorantGaramondRegular', label: 'Cormorant Garamond Regular' },
    { value: 'CaslonGraphiqueOpti', label: 'Caslon Graphique Opti' },
    { value: 'FsLolaBold', label: 'Fs Lola Bold' },
    { value: 'FuturaLt', label: 'Futura LT' },
    { value: 'FuturaLtBold', label: 'Futura LT Bold' },
    { value: 'GillSansMtProLight', label: 'GillSans MT Pro Light' },
    { value: 'GtZirkon', label: 'GT Zirkon' },
    { value: 'HelveticaNeueLight', label: 'Helvetica Neue Light' },
    { value: 'ItcNewBaskervilleRoman', label: 'ITC New Baskerville Roman' },
    { value: 'LatoBlack', label: 'Lato Black' },
    { value: 'LatoBlackItalic', label: 'Lato Black Italic' },
    { value: 'LatoBold', label: 'Lato Bold' },
    { value: 'LatoBoldItalic', label: 'Lato Bold Italic' },
    { value: 'LatoItalic', label: 'Lato Italic' },
    { value: 'LatoLight', label: 'Lato Light' },
    { value: 'LatoLightItalic', label: 'Lato Light Italic' },
    { value: 'LatoRegular', label: 'Lato Regular' },
    { value: 'LatoThin', label: 'Lato Thin' },
    { value: 'LatoThinItalic', label: 'Lato Thin Italic' },
    { value: 'LinotypeTradeGothic', label: 'Linotype Trade Gothic - Regular' },
    { value: 'LinotypeTradeGothicBold', label: 'Linotype Trade Gothic - Bold' },
    { value: 'MontserratBold', label: 'Montserrat Bold' },
    { value: 'MontserratMedium', label: 'Montserrat Medium' },
    { value: 'MontserratRegular', label: 'Montserrat Regular' },
    { value: 'MrEavesXLSanNarOTRegular', label: 'Mr Eaves XL San Nar OT Regular' },
    { value: 'MrEavesXLSanOTBold', label: 'Mr Eaves XL San OT Bold' },
    { value: 'MrEavesXLSanOTLight', label: 'Mr Eaves XL San OT Light' },
    { value: 'MreavesxItalic', label: 'Mr Eaves X Italic' },
    { value: 'NeutraTextBold', label: 'Neutra Text Bold' },
    { value: 'NeutraTextBook', label: 'Neutra Text Book' },
    { value: 'OpenSansRegular', label: 'Open Sans' },
    { value: 'PoppinsLight', label: 'Poppins Light' },
    { value: 'PoppinsRegular', label: 'Poppins Regular' },
    { value: 'RalewayRegular', label: 'Raleway Regular' },
    { value: 'RobotoBold', label: 'Roboto Bold' },
    { value: 'RobotoRegular', label: 'Roboto Regular' },

    { value: 'TTNormsBold', label: 'TTNorms Bold' },
    { value: 'TTNormsLight', label: 'TTNorms Light' },
    { value: 'TTNormsRegular', label: 'TTNorms Regular' },
  ];

  @observable currencies = [
    { value: '$', label: 'Australian Dollar - $' },
    { value: '₱', label: 'Philippine Peso - ₱' },
    { value: '$', label: 'Singapore Dollar - $' },
    { value: '$', label: 'United States Dollar - $' },
    { value: '$', label: 'Hong Kong Dollar - $' },
    { value: '฿', label: 'Thailand Baht - ฿' },
    { value: '¥', label: 'Japan Yen - ¥' },
    { value: '¥', label: 'China Yuan Renminbi - ¥' },
    { value: 'Rp', label: 'Indonesia Rupiah - Rp' },
    { value: 'ر.س', label: 'Saudi Riyal - ر.س' },
    { value: 'C$', label: 'Canadian dollar - C$' },
  ];

  @observable timezones = [
    { value: 'Australia/Adelaide', label: '(GMT+10:30) Australia Adelaide' },
    { value: 'Asia/Singapore', label: '(GMT+08:00) Singapore' },
    { value: 'Asia/Bangkok', label: '(GMT+07:00) Bangkok' },
    { value: 'Asia/Hong_Kong', label: '(GMT+08:00) Hong Kong' },
    { value: 'Asia/Tokyo', label: '(GMT+09:00) Tokyo' },
    { value: 'Asia/Jakarta', label: '(GMT+07:00) Indonesia' },
    { value: 'Asia/Riyadh', label: '(GMT+03:00) Riyadh' },
    { value: 'America/Toronto', label: '(GMT-04:00) Toronto' }
  ];

  @observable data = null;

  @action getData() {
    const languageCode = window.localStorage.getItem('lang') || 'en';
    return apiCaller.WebSettings.get(languageCode).then(resp => {
      if (!resp.isError) {
        if (resp.data) {
          this.data = resp.data;
        }
      }
    })
  }

  @action update() {
    return apiCaller.WebSettings.update(this.data.id, this.data);
  }

  @action setcurrencyCountry(value) {
    this.data.currencyCountry = value;

    const currency = this.currencies.find(fi => fi.label === value);
    this.data.currencyCode = currency.value;
  }

  // GENERAL

  @action settimezone(value) {
    this.data.timezone = value;
  }

  @action settenantId(value) {
    this.data.tenantId = value;
  }

  @action setlocation(value) {
    this.data.location = value;
  }

  @action sethomeImageUrl(value) {
    this.data.homeImageUrl = value;
  }

  @action setloginImageUrl(value) {
    this.data.loginImageUrl = value;
  }

  @action setlogoImageUrl(value) {
    this.data.logoImageUrl = value;
  }

  @action setHotelMapImageUrl(value) {
    this.data.hotelMapImageUrl = value;
  }

  @action setisHotelFacilityCarousel(value) {
    this.data.isHotelFacilityCarousel = value;
  }

  @action setisHotelOfferCarousel(value) {
    this.data.isHotelOfferCarousel = value;
  }

  // TRANSLATION

  @action setaboutHotelText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.aboutHotelText = value;
    }
  }

  @action setaddToCartText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.addToCartText = value;
    }
  }

  @action setbackToHomeText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.backToHomeText = value;
    }
  }

  @action setbackToMenuText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.backToMenuText = value;
    }
  }

  @action setbillDetailText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.billDetailText = value;
    }
  }

  @action setbookText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.bookText = value;
    }
  }

  @action setbookNowText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.bookNowText = value;
    }
  }

  @action setbookingDateText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.bookingDateText = value;
    }
  }

  @action setbookingTimeText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.bookingTimeText = value;
    }
  }

  @action setcancelText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.cancelText = value;
    }
  }

  @action setcarTypeText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.carTypeText = value;
    }
  }

  @action setchatText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.chatText = value;
    }
  }

  @action setchoiceOfDeliveryText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.choiceOfDeliveryText = value;
    }
  }

  @action setconfirmText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.confirmText = value;
    }
  }

  @action setconfirmYourBookingText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.confirmYourBookingText = value;
    }
  }

  @action setdestinationText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.destinationText = value;
    }
  }

  @action setdetailText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.detailText = value;
    }
  }

  @action setfnbOfferText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.fnbOfferText = value;
    }
  }

  @action setgoToCartText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.goToCartText = value;
    }
  }

  @action setgoToOrderText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.goToOrderText = value;
    }
  }

  @action sethomeText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.homeText = value;
    }
  }

  @action sethotelEventText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.hotelEventText = value;
    }
  }

  @action sethotelFacilityText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.hotelFacilityText = value;
    }
  }

  @action setinProgressText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.inProgressText = value;
    }
  }

  @action setitemText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.itemText = value;
    }
  }

  @action setloadingDataText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.loadingDataText = value;
    }
  }

  @action setloginText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.loginText = value;
    }
  }

  @action setlogoutText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.logoutText = value;
    }
  }

  @action setnextText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.nextText = value;
    }
  }

  @action setnoDataFoundText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.noDataFoundText = value;
    }
  }

  @action setnoOfPersonText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.noOfPersonText = value;
    }
  }

  @action setnoOrderFoundText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.noOrderFoundText = value;
    }
  }

  @action setnotAvailableText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.notAvailableText = value;
    }
  }

  @action setokText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.okText = value;
    }
  }

  @action setorderText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.orderText = value;
    }
  }

  @action setorderPopupTitleText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.orderPopupTitleText = value;
    }
  }

  @action setorderPopupSuccessText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.orderPopupSuccessText = value;
    }
  }

  @action setorderPopupFailedText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.orderPopupFailedText = value;
    }
  }

  @action setpaymentTypeText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.paymentTypeText = value;
    }
  }

  @action setpleaseChooseText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.pleaseChooseText = value;
    }
  }

  @action setplaceholderLastnameText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.placeholderLastnameText = value;
    }
  }

  @action setplaceholderRoomText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.placeholderRoomText = value;
    }
  }

  @action setpleaseSelectMenuOptionText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.pleaseSelectMenuOptionText = value;
    }
  }

  @action setpleaseSelectYourOrderText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.pleaseSelectYourOrderText = value;
    }
  }

  @action setpreferredDateText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.preferredDateText = value;
    }
  }

  @action setpreferredTimeText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.preferredTimeText = value;
    }
  }

  @action setpreferredTimeNowText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.preferredTimeNowText = value;
    }
  }

  @action setpreferredTime15MinutesLaterText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.preferredTime15MinutesLaterText = value;
    }
  }

  @action setpreferredTime30MinutesLaterText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.preferredTime30MinutesLaterText = value;
    }
  }

  @action setpreferredTime1HourLaterText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.preferredTime1HourLaterText = value;
    }
  }

  @action setprocessingOrderLoadingText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.processingOrderLoadingText = value;
    }
  }

  @action setrecommendationForYouText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.recommendationForYouText = value;
    }
  }

  @action setremarkText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.remarkText = value;
    }
  }

  @action setrequestText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.requestText = value;
    }
  }

  @action setreservedText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.reservedText = value;
    }
  }

  @action setroomText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.roomText = value;
    }
  }

  @action setscheduleText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.scheduleText = value;
    }
  }

  @action setsearchText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.searchText = value;
    }
  }

  @action setsendMessageText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.sendMessageText = value;
    }
  }

  @action setserviceText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.serviceText = value;
    }
  }

  @action setserviceFeeText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.serviceFeeText = value;
    }
  }

  @action setshoppingOfferText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.shoppingOfferText = value;
    }
  }

  @action setsoonText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.soonText = value;
    }
  }

  @action setsubTotalText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.subTotalText = value;
    }
  }

  @action setselectTimeText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.selectTimeText = value;
    }
  }

  @action setthisServiceIsUnavailableText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.thisServiceIsUnavailableText = value;
    }
  }

  @action settotalBillText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.totalBillText = value;
    }
  }

  @action setvatText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.vatText = value;
    }
  }

  @action setwelcomeText(langId, value) {
    let lang = this.data.webSettingLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.welcomeText = value;
    }
  }
}

export default new webSettingStore();